import React, { useState, useRef } from "react";
import DropdownList from "../../../Patient/partial/DropdownList";

function NewVitalForm({ onCancel, onSubmit }) {
    // local state
    const [model, setModel] = useState({ questions: [] });
    const [care, setCare] = useState(null);
    const initialRef = useRef();
    const frequencyRef = useRef();

    const onChange = (key, answer, value = 0) => {
        let newModel = { ...model };
        let found = false;
        for (let i = 0; i < newModel.questions.length; i++) {
            if (key === newModel.questions[i].question) {
                found = true;
                newModel.questions[i].question = key;
                newModel.questions[i].answer = answer;
                newModel.questions[i].value = value + "";
            }
        }
        if (!found) {
            newModel.questions.push({
                question: key,
                answer,
                value: value + ""
            });
        }
        setModel(newModel);
    };

    const onRespirationChange = (key, value) => {
        // found the range
        if (value <= 8 || value >= 25) {
            onChange(key, value, 3);
        } else if (value >= 9 && value <= 11) {
            onChange(key, value, 1);
        } else if (value >= 12 && value <= 20) {
            onChange(key, value);
        } else if (value >= 21 && value <= 24) {
            onChange(key, value, 2);
        }
        // Update model
    };
    const scale1 = (key, value) => {
        if (value <= 91) {
            onChange(key, value, 3);
        } else if (value >= 92 && value <= 93) {
            onChange(key, value, 2);
        } else if (value >= 94 && value <= 95) {
            onChange(key, value, 1);
        } else {
            onChange(key, value);
        }
    };
    const scale2 = (key, value) => {
        if (value <= 91) {
            onChange(key, value, 3);
        } else if (value >= 92 && value <= 93) {
            onChange(key, value, 2);
        } else if (value >= 94 && value <= 95) {
            onChange(key, value, 1);
        } else {
            onChange(key, value);
        }
    };
    const onBloodChange = (key, value) => {
        if (value <= 90) {
            onChange(key, value, 3);
        } else if (value >= 91 && value <= 100) {
            onChange(key, value, 2);
        } else if (value >= 101 && value <= 110) {
            onChange(key, value, 1);
        } else if (value >= 220) {
            onChange(key, value, 3);
        } else {
            onChange(key, value);
        }
    };

    const onPulseChange = (key, value) => {
        if (value <= 40) {
            onChange(key, value, 3);
        } else if (value >= 111 && value <= 130) {
            onChange(key, value, 2);
        } else if ((value >= 41 && value <= 50) || (value >= 91 && value <= 100)) {
            onChange(key, value, 1);
        } else if (value >= 131) {
            onChange(key, value, 3);
        } else {
            onChange(key, value);
        }
    };
    const onTempChange = (key, value) => {
        if (value <= 35.0) {
            onChange(key, value, 3);
        } else if (value >= 39.1) {
            onChange(key, value, 2);
        } else if ((value >= 38.1 && value <= 39.0) || (value >= 35.1 && value <= 36.0)) {
            onChange(key, value, 1);
        } else if (value >= 39.1) {
            onChange(key, value, 3);
        } else {
            onChange(key, value);
        }
    };

    return (
        <form
            onSubmit={node => {
                node.preventDefault();
                onSubmit({
                    care,
                    questions: model.questions,
                    initial: initialRef.current.value,
                    frequency: frequencyRef.current.value,
                    score: model.questions.map(i => parseInt(i.value)).reduce((p, i) => p + i)
                });
            }}
        >
            <table className="table table-bordered">
                <tbody>
                    <tr>
                        <td style={{ width: "30%" }} className="bg-blue">
                            <h1 className="display-3">A&B</h1>
                            Respirations <br />
                            Breaths/min
                        </td>
                        <td style={{ width: "70%" }}>
                            <input
                                type="number"
                                className="form-control input-height"
                                id="respiration-id"
                                required
                                min="0"
                                onChange={({ target }) => onRespirationChange("Respirations", target.value)}
                                aria-describedby="respiration-id"
                                placeholder="enter respiration"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td style={{ width: "30%" }} className="bg-blue">
                            <h1 className="display-3">A&B</h1>
                            SpO<sub>2</sub> Scale 1
                        </td>
                        <td style={{ width: "70%" }}>
                            <div className="form-group">
                                <input
                                    type="number"
                                    className="form-control input-height"
                                    id="spo2-id"
                                    required
                                    onChange={({ target }) => scale1("SpO2 (Scale 1)", target.value)}
                                    aria-describedby="spo2-id"
                                    placeholder="enter value here"
                                />
                                <small id="spo2-id-hint" className="form-text text-muted">
                                    Oxygen saturation (%)
                                </small>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ width: "30%", backgroundColor: "aliceblue" }}>
                            <h1>A&B</h1> SpO<sub>2</sub> Scale 2 - Oxygen saturation (%)
                            <small>Use Scale 2 if target range is 88-92%, e.g in hypercapnic respiratory failure</small>
                            <br />
                            <br />
                            <small className="text-danger mt-2">Only use Scale 2 under the direction of a qualified clinician</small>
                        </td>
                        <td style={{ width: "70%" }}>
                            <div className="form-group">
                                <input
                                    type="number"
                                    className="form-control input-height"
                                    id="spo2-id-2"
                                    aria-describedby="spo2-id-2"
                                    onChange={({ target }) => scale2("A&B - SpO2 (Scale 2 - Oxygen saturation (%))", target.value)}
                                    placeholder="enter value here"
                                />
                                <small id="spo2-id-2-hint" className="form-text text-muted"></small>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ width: "30%" }} className="bg-blue">
                            <h4>Air or Oxygen</h4>
                        </td>
                        <td style={{ width: "70%" }}>
                            <div className="form-group">
                                <DropdownList
                                    title=""
                                    items={[
                                        { id: 1, name: "Air", value: "A", rep: 0 },
                                        { id: 2, name: "Oxygen", value: "02 L/min", rep: 2 },
                                        { id: 3, name: "Device", value: "Device", rep: 0 }
                                    ]}
                                    onSelect={item => onChange("Air or Oxygen", item.value, item.rep)}
                                />
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ width: "30%" }} className="bg-blue">
                            <h1>C</h1>
                            Blood Pressure
                            <small>mmHg</small>
                            <br />
                            <span className="text-muted">Score uses systolic BP only</span>
                        </td>
                        <td style={{ width: "70%" }}>
                            <div className="form-group">
                                <input
                                    type="number"
                                    className="form-control input-height"
                                    id="bp-id-2"
                                    required
                                    onChange={({ target }) => onBloodChange("Blood Pressure (mmHg)", target.value)}
                                    aria-describedby="bp-id-2"
                                    placeholder="enter value here"
                                />
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ width: "30%" }} className="bg-blue">
                            <h1>C</h1>
                            Pulse <br />
                            <small> Beats/min</small>
                        </td>
                        <td style={{ width: "70%" }}>
                            <div className="form-group">
                                <input
                                    type="number"
                                    className="form-control input-height"
                                    id="pulse-id-2"
                                    required
                                    onChange={({ target }) => onPulseChange("Pulse", target.value)}
                                    aria-describedby="pulse-id-2"
                                    placeholder="enter value here"
                                />
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ width: "30%" }} className="bg-blue">
                            <h1>D</h1>
                            Consciousness <br />
                            <small>Score for NEW onset of confusion (no score if chronic)</small>
                        </td>
                        <td style={{ width: "70%" }}>
                            <div className="form-group">
                                <DropdownList
                                    items={[
                                        { id: 1, name: "Alert", value: "Alert", rep: 0 },
                                        {
                                            id: 2,
                                            name: "Confusion",
                                            value: "Confusion",
                                            rep: 3
                                        },
                                        { id: 3, name: "V", value: "V", rep: 3 },
                                        { id: 4, name: "P", value: "P", rep: 3 },
                                        { id: 5, name: "U", value: "U", rep: 3 }
                                    ]}
                                    onSelect={item => onChange("Consciousness", item.value, item.rep)}
                                />
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ width: "30%" }} className="bg-blue">
                            <h1>E</h1>
                            Temperature <br />
                            <sup>0</sup>C
                        </td>
                        <td style={{ width: "70%" }}>
                            <div className="form-group">
                                <input
                                    type="text"
                                    className="form-control input-height"
                                    id="Temperature-id-2"
                                    required
                                    onChange={({ target }) => onTempChange("Temperature", target.value)}
                                    aria-describedby="Temperature-id-2"
                                    placeholder="enter value here"
                                />
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>

            {model.questions.length > 0 && (
                <div className="form-group fade-in text-center">
                    <strong>Score</strong>
                    <h2 className="text-success">{model.questions.map(i => parseInt(i.value)).reduce((p, i) => p + i)}</h2>
                </div>
            )}
            <div className="form-row mb-5">
                <div className="col-12 col-md-4">
                    <label htmlFor="Frequency-id-2">Monitoring Frequency:</label>
                    <input type="text" className="form-control input-height" id="Frequency-id-2" ref={frequencyRef} aria-describedby="Frequency-id-2" placeholder="enter Frequency" />
                </div>
                <div className="col-12 col-md-4">
                    <DropdownList
                        title="EScalation of Care:"
                        items={[
                            { id: 1, name: "Yes", value: "Yes" },
                            { id: 2, name: "No", value: "No" }
                        ]}
                        onSelect={item => setCare(item.value)}
                    />
                </div>
                <div className="col-12 col-md-4">
                    <label htmlFor="Initial-id-2">Initial:</label>
                    <input type="text" className="form-control input-height" id="Initial-id-2" ref={initialRef} aria-describedby="Initial-id-2" placeholder="enter Initial" />
                </div>
            </div>

            <div className="text-center mt-5">
                <button type="submit" className="mdl-button mdl-button--raised mdl-js-ripple-effect m-l-10  margin-right-10 btn-circle btn-success">
                    Submit Vital
                    <i className="material-icons">arrow_right_alt</i>
                </button>

                <button type="button" onClick={onCancel} className="mdl-button mdl-button--raised mdl-js-ripple-effect m-l-10  btn-circle btn-default">
                    <i className="material-icons text-danger">cancel</i> Cancel
                </button>
            </div>
        </form>
    );
}
export default NewVitalForm;
